export default {
  open: 2,
  won: 1,
  removed: 3,
  cold: 4,
};
